import React from 'react';
import styled, { css } from 'styled-components';

import WhyMirtaItem from './WhyMirtaItem';
import {
  IImageWithTextData,
  IImageWithTextDataCmp,
} from '../IImageWithTextCmp';

const Container = styled.div<IContainer>`
  display: grid;
  ${props =>
    props.numberItems <= 3 &&
    css`
      grid-template-columns: repeat(1, 1fr);
    `}
  ${props =>
    props.numberItems > 3 &&
    css<IContainer>`
      grid-template-columns: repeat(4, 1fr);
    `}
	
	column-gap: 16px;
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
  padding-left: 8px;
  padding-right: 8px;

  ${p => p.theme.breakpoints.up('sm')} {
    grid-template-columns: ${props => `repeat(${props.numberItems}, 1fr)`};
    padding-left: 32px;
    padding-right: 32px;
  }
  ${p => p.theme.breakpoints.up('md')} {
    padding-left: 56px;
    padding-right: 56px;
  }
`;

interface IContainer {
  numberItems: number;
  bgColor: string | undefined;
}

const ImageWithTextWhyMirta: React.FC<IImageWithTextDataCmp> = props => {
  const { imageWithTextData, bgColor } = props;
  let listOfImageWithText: (React.ReactElement | undefined)[] = [];
  if (imageWithTextData && imageWithTextData.length > 0) {
    listOfImageWithText = imageWithTextData.map(
      (singleElement: IImageWithTextData, index: number) => {
        if (singleElement) {
          return (
            <WhyMirtaItem
              key={`${singleElement.id}_${index}`}
              numberOfItems={imageWithTextData.length}
              {...singleElement}
            />
          );
        }
      }
    );
  }

  return imageWithTextData && imageWithTextData.length > 0 ? (
    <Container numberItems={imageWithTextData.length} bgColor={bgColor}>
      {listOfImageWithText}
    </Container>
  ) : null;
};

export default ImageWithTextWhyMirta;
